import { render } from "./AdminSelfRegistrationIntakeWorkflow.vue?vue&type=template&id=1bdeb00d&scoped=true"
import script from "./AdminSelfRegistrationIntakeWorkflow.vue?vue&type=script&lang=js"
export * from "./AdminSelfRegistrationIntakeWorkflow.vue?vue&type=script&lang=js"

import "./AdminSelfRegistrationIntakeWorkflow.vue?vue&type=style&index=0&id=1bdeb00d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdeb00d"]])

export default __exports__